<div class="fp-shell" *ngIf="hasOptions$ | async">
  <div class="fp-header">
    <h2 class="fp-title">Bit Features</h2>
    <span class="fp-muted">{{ selectedIdsSet.size }} selected</span>
  </div>

  <div class="fp-grid">
    <!-- LEFT -->
    <section class="fp-card">
      <h3 class="fp-card-title">{{ titleLeft || 'Available Features' }}</h3>
      <div class="fp-search">
        <input
          kendoTextBox
          type="text"
          placeholder="Search features"
          [value]="searchTerm"
          (input)="onSearch($any($event.target).value)" />
        <button
          *ngIf="searchTerm"
          kendoButton
          fillMode="flat"
          type="button"
          (click)="onSearch('')">
          Clear
        </button>
      </div>
      <kendo-panelbar [expandMode]="expandMode">
        <kendo-panelbar-item
          *ngFor="let g of groupsVM; trackBy: trackGroup"
          [title]="g.label">
          <ng-template kendoPanelBarContent>
            <div class="fp-options">
              <label class="fp-row peach"
                     *ngFor="let o of g.options; trackBy: trackOption"
                     [attr.for]="'chk-' + g.id + '-' + o.id">
                <input
                    type="checkbox"
                  kendoCheckBox
                  [attr.id]="'chk-' + g.id + '-' + o.id"
                  [checked]="isSelected(o.id)"
                  (change)="toggle(o.id)" />
                <span class="fp-label">{{ o.label }}</span>
                <span title="Feature is not included in Marketing Sheet"
                        *ngIf="o.raw.IsDisplayedInMarketingSheet"><img src="assets/images/mksheetCross.png"
                          style="height: 24px;"></span>
                <span title="Cost Saving Feature"
                        *ngIf="o.raw.IsCostSavingFeature"><img src="assets/images/CostSavings.png"
                          style="height: 24px;"></span>
              </label>
            </div>
          </ng-template>
        </kendo-panelbar-item>
      </kendo-panelbar>
    </section>

    <!-- RIGHT -->
    <section class="fp-card">
      <div class="fp-card-header">
        <h3 class="fp-card-title">{{ titleRight || 'Selected Features' }}</h3>
        <button kendoButton fillMode="flat" (click)="clearAll()" [disabled]="disableClear || selectedIdsSet.size === 0">
          Clear all
        </button>
      </div>

      <ng-container *ngIf="selectedGroups().length; else empty">
        <div class="fp-selected">
          <div class="fp-group" *ngFor="let g of selectedGroups(); trackBy: trackGroup">
            <div class="fp-green-header">{{ g.label }}</div>
            <div class="fp-options">
              <div class="fp-row grey" *ngFor="let o of g.options; trackBy: trackOption">
                <button type="button" class="fp-chip-x" (click)="toggle(o.id)" aria-label="Remove">✕</button>
                <span class="fp-label">{{ o.label }}</span>
                <span title="Feature is not included in Marketing Sheet"
                        *ngIf="o.raw.IsDisplayedInMarketingSheet"><img src="assets/images/mksheetCross.png"
                          style="height: 24px;"></span>
                <span title="Cost Saving Feature"
                        *ngIf="o.raw.IsCostSavingFeature"><img src="assets/images/CostSavings.png"
                          style="height: 24px;"></span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #empty>
        <div class="fp-empty">No features selected yet. Choose from the left.</div>
      </ng-template>
    </section>
  </div>
</div>
